import { FetchApiError, instanceOfErrorResponse } from "@repo/api";

export type ChangeRequestResultStatus = "success" | "processing" | "failed";

const STAR_PENSION_CALL_BLOCKED_ERROR_CODE = 423;

const isObject = (value: unknown): value is Record<string, unknown> => {
    return typeof value === "object" && value !== null;
};

const getErrorResponse = (error: unknown): object | undefined => {
    if (error instanceof FetchApiError) {
        return error.errorResponse as object;
    }

    if (!isObject(error)) {
        return undefined;
    }

    if (instanceOfErrorResponse(error)) {
        return error;
    }

    const response = error.response;

    if (!isObject(response)) {
        return undefined;
    }

    const data = response.data;

    return isObject(data) ? data : undefined;
};

export const isChangeRequestBlockedError = (error: unknown): boolean => {
    const errorResponse = getErrorResponse(error);

    return (
        errorResponse !== undefined &&
        instanceOfErrorResponse(errorResponse) &&
        Number(errorResponse.code) === STAR_PENSION_CALL_BLOCKED_ERROR_CODE
    );
};

export const mapChangeRequestStatus = (error?: unknown): ChangeRequestResultStatus => {
    if (!error) {
        return "success";
    }

    return isChangeRequestBlockedError(error) ? "processing" : "failed";
};
